export enum AuthorizationStatus {
  Auth = 'Auth',
  NoAuth = 'NoAuth',
  Unknown = 'Unknown',
}

export const BASE_URL = 'https://api.tgparsing.com';

export const TIMEZONES = [
  { value: 1, text: 'timeZones.timeZone1' },
  { value: 2, text: 'timeZones.timeZone2' },
  { value: 3, text: 'timeZones.timeZone3' },
  { value: 4, text: 'timeZones.timeZone4' },
  { value: 5, text: 'timeZones.timeZone5' },
  { value: 6, text: 'timeZones.timeZone6' },
  { value: 7, text: 'timeZones.timeZone7' },
  { value: 8, text: 'timeZones.timeZone8' },
  { value: 9, text: 'timeZones.timeZone9' },
  { value: 10, text: 'timeZones.timeZone10' },
  { value: 11, text: 'timeZones.timeZone11' },
  { value: 12, text: 'timeZones.timeZone12' },
];

export enum Modes {
  Admin = 'admin',
  User = 'user',
}

export enum Roles {
  Admin = 'admin',
  User = 'user',
  SuperUser = 'superuser',
}

export enum Parsers {
  Members = 'members',
  ActiveMembers = 'activemembers',
  GeoMembers = 'geomembers',
}

const currentDate = new Date();
const year = currentDate.getFullYear();
const month = String(currentDate.getMonth() + 1).padStart(2, '0');
const day = String(currentDate.getDate()).padStart(2, '0');
const dayPlusThreeDay = String(currentDate.getDate() + 3).padStart(2, '0');
const dayPlusTwoDay = String(currentDate.getDate() + 2).padStart(2, '0');
const dayPlusOneDay = String(currentDate.getDate() + 1).padStart(2, '0');
const hours = String(currentDate.getHours()).padStart(2, '0');
const minutes = String(currentDate.getMinutes()).padStart(2, '0');
const seconds = String(currentDate.getSeconds()).padStart(2, '0');
const milliseconds = String(currentDate.getMilliseconds()).padStart(3, '0');

export const CURRENT_DATE_STRING = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}`;
export const CURRENT_DATE_STRING_PLUS_THREE_DAY = `${year}-${month}-${dayPlusThreeDay}T${hours}:${minutes}:${seconds}.${milliseconds}`;
export const CURRENT_DATE_STRING_PLUS_TWO_DAY = `${year}-${month}-${dayPlusTwoDay}T${hours}:${minutes}:${seconds}.${milliseconds}`;
export const CURRENT_DATE_STRING_PLUS_ONE_DAY = `${year}-${month}-${dayPlusOneDay}T${hours}:${minutes}:${seconds}.${milliseconds}`;
